import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields/';

const list = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/safety_diaries/list`),
    params,
  });
};

// api :GET, '/api/private/fields/:field_id/safety_diaries/search_list', '巡回記録検索結果一覧を返します'
const searchList = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/safety_diaries/search_list`),
    params,
  });
};

// api :GET, '/api/private/fields/:field_id/safety_diaries/:id', '情報を取得します'
const getDiary = (fieldId, dataId, params) => {
  return requestWithToken(
    {
      method: 'GET',
      url: path.concat(`${fieldId}/safety_diaries/${dataId}`),
      params,
    },
    false
  );
};

const register = (fieldId, params) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`${fieldId}/safety_diaries`),
    data: params,
  });
};

const update = (fieldId, dataId, params) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`${fieldId}/safety_diaries/${dataId}`),
    data: params,
  });
};

const registerRecovery = (fieldId, dataId, params) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`${fieldId}/safety_diaries/${dataId}/report`),
    data: params,
  });
};

const deleteDiary = (fieldId, dataId) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`${fieldId}/safety_diaries/${dataId}`),
  });
};

const approval = (fieldId, dataId, params) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`${fieldId}/safety_diaries/${dataId}/approval`),
    data: params,
  });
};

export const SafetyDiaryService = {
  list,
  searchList,
  getDiary,
  register,
  update,
  deleteDiary,
  registerRecovery,
  approval,
};
export default SafetyDiaryService;



// WEBPACK FOOTER //
// ./src/services/SafetyDiaries.js